module.exports = __webpack_public_path__ + "img/professional.98bb6666.svg";